import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToAnchor() {
  const location = useLocation();
  const lastHash = useRef('');

  useEffect(() => {
    if (location.hash) {
      lastHash.current = location.hash.replace('#', '');
    }

    if (!lastHash.current) return;

    const element = document.getElementById(lastHash.current);
    if (!element) return;

    setTimeout(() => {
      element.scrollIntoView({
        behavior: 'auto',
        block: 'start'
      });
      lastHash.current = '';
    }, 100);
  }, [location]);

  return null;
}